import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";


export function saveTutorRightSettings(userId, instanceId, rights, btn){

    const url = '/instance/' + instanceId.toString() + '/tutor/' + userId.toString() + '/rights/save'

    const data = {
        rights: rights
    }

    const success = function (data){
        const myModalEl = document.getElementById("set-tutor-settings");
          const myModal = new bootstrap.Modal(myModalEl, {});
  
          // now change symbols
          const rights = data.rights;
          const rightIcons = $("td.editing").find(".right-icon");
  
          rightIcons.each(function(ind,obj){
            const rightId = parseInt($(obj).attr('data-right'));
            if (rights[rightId] == "true"){
              $(obj).addClass("btn-light-success text-success").removeClass("btn-light-danger text-danger");
            } else {
              $(obj).removeClass("btn-light-success text-success").addClass("btn-light-danger text-danger");
            }
          });
          myModal.hide();
          successToast("Einstellungen gespeichert", '', 3500, false);
    }

    return ajaxRequest(url, success, data, btn)

}
